import { ReactNode, useEffect, useReducer } from 'react';
import { ApplicationContext } from './context';
import { rootReducer } from './reducer';
import { initialState, initializer } from './state';

/**
 * @deprecated
 */
export const ApplicationDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, dispatch] = useReducer(rootReducer, initialState, initializer);

  useEffect(() => {
    sessionStorage.setItem('applicationData', JSON.stringify(state));
  }, [state]);

  return (
    <ApplicationContext.Provider value={{ state, dispatch }}>
      {children}
    </ApplicationContext.Provider>
  );
};
